// extracted by mini-css-extract-plugin
export var container = "_5q-0";
export var infoButton = "_5q-1";
export var label = "_5q-3";
export var labelExpanded = "_5q-4";
export var price = "_5q-5";
export var priceExpanded = "_5q-6";
export var title = "_5q-2";